/*---------------------------------------------------------------
  CALCULATION SETTING LEASING 
---------------------------------------------------------------*/

export interface Leasing {
  id: string;
  leasingTypeId: string | null;
  leasingTypeName: string | null;
  name: string | null;
  interestRate: number | null;
}

/*---------------------------------------------------------------
  CALCULATION SETTING LEASING - SEARCH
---------------------------------------------------------------*/
export interface LeasingRow {
  id: string;
  name: string;
  leasingTypeName: string;
  interestRate: number;
}

export interface LeasingSearchFormValues {
  search: string | null;
}

/*---------------------------------------------------------------
  CALCULATION SETTING LEASING EDIT
---------------------------------------------------------------*/
export interface LeasingEditFormValues {
  id?: string | null;
  leasingTypeId: string | null;
  name: string | null;
  interestRate: number | null;
}

/*---------------------------------------------------------------
   CALCULATION SETTING LEASING DETAIL
---------------------------------------------------------------*/

export interface LeasingDetailFormValues {
  id: string | null;
  leasingTypeId: string | null;
  leasingTypeName: string | null;
  name: string | null;
  interestRate: number | null;
}

/*---------------------------------------------------------------
  CALCULATION SETTING LEASING TYPE
---------------------------------------------------------------*/

export enum LeasingType {
  O = "Operativni leasing",
  F = "Financijski leasing",
}
